// Text-free SVG masters and PNG social previews for non-product pages.
export const PAGE_SOCIAL_IMAGE_ROUTES = [
  {key:'scan',path:'/scan-qr-code',icon:'scan',color:'#168C8D'},
  {key:'help',path:'/help',icon:'help',color:'#4778A8'},
  {key:'knowledge',path:'/what-is-qr-code',icon:'knowledge',color:'#547B55'},
  {key:'pricing',path:'/service-pack',icon:'pricing',color:'#8D63B5'},
  {key:'contact',path:'/contact',icon:'contact',color:'#337D9B'},
  {key:'privacy',path:'/privacy-policy',icon:'privacy',color:'#39836C'},
  {key:'terms',path:'/term-of-use',icon:'terms',color:'#72719A'},
  {key:'blog',path:'/blog',icon:'blog',color:'#BD7853'},
  {key:'useCases',path:'/use-cases',icon:'useCases',color:'#538B71'},
  {key:'document',path:'/document',icon:'document',color:'#507FAC'},
  {key:'dashboard',path:'/dashboard',icon:'dashboard',color:'#487A8B'},
  {key:'resetPassword',path:'/reset-password',icon:'resetPassword',color:'#7763A2'}
];
const aliases = {
  '/qr-code-la-gi':'/what-is-qr-code', '/goi-dich-vu':'/service-pack',
  '/lien-he':'/contact', '/chinh-sach-bao-mat':'/privacy-policy',
  '/dieu-khoan-su-dung':'/term-of-use'
};
const imagesByPath = Object.fromEntries(PAGE_SOCIAL_IMAGE_ROUTES.map(route =>
  [route.path, `/images/og/pages/${route.path.slice(1)}.png`]
));
const normalize = pathname => {
  const value = String(pathname || '/').split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  return aliases[value] || value;
};
export const getPageSocialImage = pathname => {
  const path = normalize(pathname);
  if (imagesByPath[path]) return imagesByPath[path];
  const prefix = ['/help','/blog','/use-cases','/document','/dashboard'].find(base=>path.startsWith(`${base}/`));
  return prefix ? imagesByPath[prefix] : null;
};
const isGenericImage = value => {
  if (!String(value || '').trim()) return true;
  try {
    const url = new URL(value, 'https://qrcode-gen.com');
    return /(^|\.)qrcode-gen\.com$/.test(url.hostname) &&
      ['/logo.png','/images/banner1.png','/images/blog1.png'].includes(url.pathname);
  } catch (_) { return false; }
};
// Fixed pages use their new artwork. CMS articles keep custom images, with a
// category fallback only when their image is missing or the old generic logo.
export const resolvePageSocialImage = (pathname, existingImage) => {
  const path = normalize(pathname);
  const image = getPageSocialImage(path);
  if (!image) return existingImage || '';
  if (imagesByPath[path] || path.startsWith('/help/') || path.startsWith('/dashboard/') || isGenericImage(existingImage)) {
    return `https://qrcode-gen.com${image}`;
  }
  return existingImage;
};
